export const newInvoiceTool = {
  CREATE_NEW_INVOICE: "Skapa ny faktura",
  PREVIOUS_INVOICING_TOOL: "Tidigare fakturaverktyg",
  EDIT_INVOICE: "Redigera faktura begäran",
  VERSION_RESTRICTION_TITLE: "Versionsbegränsning",
  VERSION_RESTRICTION_MESSAGE: "Denna faktura skapades med Version 3 av fakturaverktyget. För att redigera denna faktura, växla till Version 3.",
  CLOSE: "Stäng",
  EDIT_REQUEST_INVOICE: "Redigera faktura begäran",
  PREVIEW: "Förhandsgranska",
  PDF_FILE_REQUIRED: "PDF-fil krävs",
  SAVE_DRAFT: "Spara utkast",
  SAVE_AND_SHARE: "Spara och dela",
  NEED_HELP: "Behöver du hjälp?",
  HELP_SUPPORT: "Hjälp & Support",
  CHAT_WITH_US: "Chatta med oss",
  FAQ: "FAQ",
  USER_GUIDE: "Användarguide",
  CREATE_NEW_INVOICE_PAGE_TITLE: "Skapa ny faktura",
  LOADING: "Laddar...",
  DRAFT_INVOICE: "Utkast Faktura",
  PRELIMINARY_INVOICE_PREVIEW: "Preliminär faktura förhandsvisning",
  PRELIMINARY_INVOICE_PDF: "Preliminär faktura PDF",
  NO_PDF_DATA_AVAILABLE: "Inga PDF-data tillgängliga",
  CHANGE_LOGO: "Ändra logotyp",
   DROP_FILE_OR: "Dra och släpp en fil eller klicka på ",
  DROP_FILE_OR_NEXT: " för att ladda upp din företagslogotyp",
  BROWSE: "Bläddra",
  LOGO_FORMAT_INFO: "Endast JPG/PNG, Max 1MB, 160x50px rekommenderas, transparent bakgrund föredras",
  LOGO_FORMAT_INFO_MOBILE: "JPG/PNG, Max 1MB",
  ATTACH_YOUR_LOGO: "Bifoga din logotyp",
  COPY_RECENT_INVOICE: "Kopiera senaste faktura",
  COPY_RECENT: "Kopiera senaste",
  CALCULATED_AMOUNTS: "Beräknade belopp",
  NET: "Netto",
  TAX: "Skatt",
  TOTAL: "Totalt",
  PENSION: "Pension",
  HOLIDAY_PAY: "Semesterersättning",
  CUSTOMER_DETAILS: "Kunduppgifter",
  EDIT_CUSTOMER: "Redigera kund",
  CUSTOMER_CREATED_SUCCESSFULLY: "Kund skapad framgångsrikt",
  SELECT_CUSTOMER: "Välj kund",
  LOADING_CUSTOMERS: "Laddar kunder...",
  SELECT_A_CUSTOMER: "Välj en kund",
  ADD_NEW_CUSTOMER: "Lägg till ny kund",
  BILLING_ADDRESS: "FAKTURERINGSADRESS",
  CUSTOMER_ADDRESS: "Kundadress",
  SERVICE_DESCRIPTION: "Tjänstebeskrivning",
  SERVICE_DESCRIPTION_TOOLTIP: "Beskriv din tjänst (max 42 tecken). Endast latinska tecken tillåts (A-Z, a-z, 0-9, mellanslag och vanlig skiljetecken).",
  ONLY_LATIN_CHARACTERS_ALLOWED: "Endast latinska tecken är tillåtna",
  SERVICE_DESCRIPTION_MAX_CHARS: "Tjänstebeskrivningen får inte överstiga 42 tecken",
  ENTER_SERVICE_DESCRIPTION: "Ange tjänstebeskrivning",
  NO_BILLING_ADDRESS_AVAILABLE: "Ingen faktureringsadress är tillgänglig",
  EDIT: "Redigera",
  CUSTOMER_ID: "Kund-ID",
  NOT_SELECTED: "Inte valt",
  YOUR_REFERENCE: "Din referens",
  CUSTOMER_REFERENCE_NAME: "Kundreferensnamn",
  ENTER_YOUR_REFERENCE_NO: "Ange ditt referensnummer",
  ENTER_CUSTOMER_REFERENCE_NAME: "Ange kundreferensnamn",
  SAVE: "Spara",
  ADD_CUSTOMER_MODAL_TITLE: "Lägg till ny kund",
  CANCEL: "Avbryt",
  NEXT: "Nästa",
  BACK: "Tillbaka",
  UPDATING: "Uppdaterar...",
  CREATING: "Skapar...",
  UPDATE_DETAILS: "Uppdatera detaljer",
  SAVE_DETAILS: "Spara detaljer",
  FAILED_TO_SAVE_CUSTOMER: "Misslyckades med att spara kund. Försök igen.",
  FAILED_TO_CREATE_CUSTOMER: "Misslyckades med att skapa kund. Försök igen.",
  FROM_INVOICE_PREFERENCES: "Från fakturapreferenser",
  
  // BusinessInformation translations
  BUSINESS_TYPE: "Företagstyp",
  SELECT: "Välj",
  PRIVATE_CUSTOMER: "Privatkund",
  BUSINESS_CUSTOMER: "Företagskund",
  BUSINESS_CONSTRUCTION: "Företag Bygg",
  CUSTOMER_FULL_NAME_BUSINESS_NAME: "Kundens fullständiga namn / Företagsnamn",
  TYPE_HERE: "Skriv här...",
  YOUR_12_DIGIT_SSN_NO: "Kundens personnummer (12 siffror)",
  ORGANIZATION_NUMBER: "Organisationsnummer",
  ONLY_NUMBERS_ALLOWED: "(Endast siffror är tillåtna)",
  TYPE_NUMBER_ONLY: "Skriv endast nummer...",
  COUNTRY: "Land",
  SWEDEN: "Sverige",
  USA: "USA",
  CANADA: "Kanada",
  PANAMA: "Panama",
  NORWAY: "Norge",
  DENMARK: "Danmark",
  FINLAND: "Finland",
  COUNTRY_SELECTION_INFO: "När du väljer ett annat land än Sverige kommer din faktura automatiskt att vara på engelska.",
  CITY: "Stad",
  ZIP_CODE: "Postnummer",
  BUSINESS_ADDRESS_LINE_1: "Företagsadress rad 1",
  BUSINESS_ADDRESS_LINE_2: "Företagsadress rad 2",
  DOES_CUSTOMER_HAVE_VAT_REGISTRATION: "Har din kund ett momsregistreringsnummer?",
  YES: "Ja",
  NO: "Nej",
  VAT_NUMBER: "Momsnummer",
  VAT_COUNTRY_CODE_AUTO_ADD: "(Vi lägger automatiskt till landskoden.)",
  
  // ContactInformation translations
  CUSTOMER_REFERENCE_NAME_LABEL: "Kundreferensnamn",
  CUSTOMER_REFERENCE_INFO: "Här anger du namnet på personen som ska godkänna din faktura eller ett ordernummer.",
  CONTACT_EMAIL: "Kontakt e-post",
  CONTACT_EMAIL_INFO: "där din faktura kommer att skickas. En kopia skickas alltid till din egen e-post.",
  CONTACT_PHONE_NUMBER: "Kontakt telefonnummer",
  SELECT_INVOICE_LANGUAGE: "Vänligen välj ditt fakturasspråk",
  SELECT_LANGUAGE_TYPE: "Välj språktyp",
  SWEDISH: "Svenska",
  ENGLISH: "Engelska",
  HOW_DO_YOU_WANT_INVOICE: "Hur ska kunden ta emot fakturan?",
  SELECT_INVOICE_TYPE: "Välj fakturatyp",
  EMAIL_SEND_TO_EMAIL: "E-post (skicka till e-postadress)",
  E_INVOICE_SEND_ELECTRONIC: "E-faktura (skicka som elektronisk faktura)",
  POST_60_SEK: "Post (60 SEK)",
  OUR_ELECTRONIC_REFERENCE: "Vår elektroniska referens",
  YOUR_ELECTRONIC_REFERENCE: "Din elektroniska referens",
  GLN_PEPPOL_ID: "GLN / Peppol ID",
  EXTRA_FIELD_1_OPTIONAL: "Extra fält 1 e-faktura (valfritt)",
  EXTRA_FIELD_2_OPTIONAL: "Extra fält 2 e-faktura (valfritt)",
  CARE_OF: "C/O",
  
  // Email delivery options
  USE_EXISTING_EMAIL_ADDRESS: "Använd befintlig e-postadress",
  SECONDARY_EMAIL_ADDRESS: "Sekundär e-postadress",
   SECONDARY_EMAIL_REQUIRED: "Sekundär e-postadress krävs",
  // Postal delivery options
  USE_EXISTING_ADDRESS: "Använd befintlig adress för postleverans",
  POSTAL_ADDRESS: "Postadress",
  POSTAL_CITY: "Postort",
  POSTAL_COUNTRY: "Postland",
  POSTAL_ZIP_CODE: "Postnummer",
  POSTAL_COUNTRY_CODE: "Postlandskod",
  
  // Preferences translations
  PREFERENCES_DESCRIPTION: "Data som anges här kommer att inkluderas på alla fakturor för denna kund.",
  PAYMENT_TERMS: "Betalningsvillkor",
  PAYMENT_TERMS_INFO: "(ange 30 dagar om inte du och kunden har kommit överens om annat)",
  PAYMENT_TERM: "Betalningsvillkor",
  DAYS_7: "7 dagar",
  DAYS_14: "14 dagar",
  DAYS_30: "30 dagar",
  DAYS_60: "60 dagar",
  DAYS_90: "90 dagar",
  
  // Edit Billing Address Modal translations
  ADD_EDIT_BILLING_ADDRESS: "Lägg till / Redigera faktureringsadress",
  STATE_COUNTY: "Stat / Län",
  ENTER_HERE: "Ange här...",
  ADDRESS_LINE: "Adressrad",
 SUBMITS: "Spara",
  STOCKHOLM: "Stockholm",
  GOTHENBURG: "Göteborg",
  MALMO: "Malmö",
  UPPSALA: "Uppsala",
  UNITED_STATES: "USA",
  UNITED_KINGDOM: "Storbritannien",
  GERMANY: "Tyskland",
  FRANCE: "Frankrike",
  SPAIN: "Spanien",
  ITALY: "Italien",
  NETHERLANDS: "Nederländerna",
  BELGIUM: "Belgien",
  AUSTRALIA: "Australien",
    BUSINESS_INFORMATION: "FÖRETAGSINFORMATION",
    CONTACT_INFORMATION: "KONTAKTINFORMATION",
    PREFERENCES: "INSTÄLLNINGAR",
  
  // Collective Invoice translations
  CREATE_COLLECTIVE_INVOICE: "Skapa kollektiv faktura",
  ITEM_DETAILS: "Artikeldetaljer",
  ARE_YOU_SURE_YOU_WANT_TO_SAVE: "Är du säker på att du vill spara fakturan?",
  SAVE_INVOICE: "Spara faktura",
  SEARCH_INVOICE_CLIENT: "Sök fakturakund...",
  SELECT_WEEK_OFF_DAYS: "Välj veckovila dagar",
  SELECT_DAYS: "Välj dagar",
  ADD_DEDUCTIONS: "Lägg till avdrag",
  ADD_FREELANCERS_WORKING_WITH_YOU: "Lägg till frilansare som arbetar med dig för ett projekt eller en byrå.",
  ADD_FRIENDS_WORKING_WITH_YOU: "Lägg till dina vänner som arbetar med dig för ett projekt eller en byrå.",
  SEARCH_FREELANCERS_BY_EMAIL_NAME: "Sök frilansare via e-post / namn",
  ADD: "Lägg till",
  ADD_COUNT: "Lägg till ({{count}})",
  PLEASE_SELECT_CUSTOMER_FIRST: "Välj först en kund",
  SUGGESTIONS: "Förslag",
  SELECT_ALL: "Välj alla",
  NO_FREELANCERS_FOUND: "Inga frilansare hittades som matchar \"{{searchValue}}\"",
  NO_FREELANCERS_AVAILABLE: "Inga frilansare tillgängliga",
  INVITE_FREELANCERS_TO_INVOZIO: "Bjud in frilansare till Invozio för att skapa kollektiva fakturor och tjäna extra lojalitetspoäng.",
  INVITE_FREELANCERS: "Bjud in frilansare",
  INVITE_FREELANCER: "Bjud in frilansare",
  INVITE_FREELANCERS_WORKING_WITH_YOU: "Bjud in frilansare som arbetar med dig för ett projekt eller en byrå.",
  INVITE_FRIENDS_WORKING_WITH_YOU: "Bjud in dina vänner som arbetar med dig för ett projekt eller en byrå.",
  ENTER_FREELANCER_EMAIL: "Ange frilansarens e-postadress här...",
  SENDING: "Skickar...",
  
  // Invoice Preferences translations
  INVOICE_PREFERENCES: "Fakturapreferenser",
  CURRENCY: "Valuta",
  ENGAGEMENT_TYPE: "Engagemangstyp",
  REGULAR_CONTINUOUS: "Regelbunden / Kontinuerlig",
  OCCASIONAL_SPORADIC: "Tillfällig / sporadisk",
  PRICING_TYPE: "Pristyp",
  HOURLY: "Per timme",
  DAILY: "Per dag",
  WEEKLY: "Per vecka",
  MONTHLY: "Per månad",
  AS_AGREED: "Enligt överenskommelse",
  VAT: "Moms",
  RUT_ROT_DEDUCTION_TYPE: "RUT/ROT Avdragstyp",
  ROT_DEDUCTION: "ROT Avdrag",
  RUT_DEDUCTION: "RUT Avdrag",
  NONE_REMOVE_RUT_ROT: "Ingen (RUT/ROT)",
  ACCOMMODATION_TYPE: "Boendetyp",
  APARTMENT: "Lägenhet",
  HOUSE: "Hus",
  BRF_ORG_NUMBER: "Brf Org. Nummer",
  APARTMENT_HOUSE_NO: "Lägenhet / Hus Nr.",
  PROPERTY: "Fastighet",
  ENTER_PROPERTY_DETAILS: "Ange fastighetsuppgifter",
  
  // Item Details translations
  ITEM_DETAILS: "Artikeldetaljer",
  HOURS_PER_DAY: "Timmar per dag",
  SELECT_TYPE: "Välj typ",
  HOURLY_PRICE: "Timpris",
  DATES: "Datum",
  SELECT_DATES: "Välj datum",
  SHOW_DATES: "Visa datum",
  SELECT_OPTION: "Välj alternativ",
  YES: "Ja",
  NO: "Nej",
  SERVICE_INVOICE: "Servicefaktura",
  WORKSHEET_PAY: "Arbetslön",
  SELECT_ACCOMMODATION_TYPE: "Välj boendetyp",
  HOTEL: "Hotell",
  OTHER: "Annat",
  SELECT_ALLOWANCE: "Välj ersättning",
  HALF_DAY: "Halvdag",
  FULL_DAY: "Heldag",
  CUSTOM_AMOUNT: "Anpassat belopp",
  PLEASE_SELECT_WORK_DATES: "Vänligen välj arbetsdatum",
  PLEASE_ENTER_PRICE: "Vänligen ange pris",
  PRICE_MUST_BE_POSITIVE: "Priset måste vara positivt",
  
  // Auto Generate Items Modal
  AUTO_GENERATE_ITEMS: "Lägg till flera rader",
  HOURS_REQUIRED: "Timmar per dag krävs",
  HOURS_INVALID_FORMAT: "Ogiltigt tidsformat. Använd hh:mm",
  PRICE_REQUIRED: "Timpris krävs",
  PLEASE_SELECT_DATES: "Vänligen välj minst ett datum",
  TASK_DETAILS_REQUIRED: "Tjänstebeskrivning krävs",
  GENERATE: "Generera",
  CANCEL: "Avbryt",
  SAVE_AS_DRAFT_AND_SWITCH: "Spara som utkast och växla",
  DRAFT_REQUIRES_CUSTOMER: "Välj en kund innan du sparar som utkast",
  DRAFT_REQUIRES_WORKING_HOURS: "Lägg till minst en arbetstidsrad innan du sparar som utkast",
  DRAFT_REQUIRES_DESCRIPTION: "Ange en giltig beskrivning (minst 20 tecken eller 3 ord) innan du sparar som utkast",
  ROT_REQUIRES_BRF_ORG_NUMBER: "BRF Org. Nummer krävs för lägenhet med ROT-avdrag",
  ROT_REQUIRES_APARTMENT_HOUSE_NO: "Lägenhet / Hus nr krävs för lägenhet med ROT-avdrag",
  ROT_REQUIRES_PROPERTY: "Fastighet krävs för hus med ROT-avdrag",
  ROT_RUT_REQUIRES_PAYMENT_PER_HOUR: "Vänligen välj minst en artikel av typen \"Betalning per timme\" för att skapa en ROT/RUT-faktura.",
  // Customer Validation Error Messages
  "Business type is required": "Företagstyp krävs",
  "Customer name is required": "Kundnamn krävs",
  "SSN is required": "Personnummer krävs",
  "SSN must be exactly 12 digits": "Personnummer måste vara exakt 12 siffror",
  "The last 4 digits of SSN cannot be all zeros.": "De sista 4 siffrorna i personnumret kan inte vara alla nollor.",
  "Organization number is required": "Organisationsnummer krävs",
  "Country is required": "Land krävs",
  "Address is required": "Adress krävs",
  "City is required": "Stad krävs",
  "ZIP code is required": "Postnummer krävs",
  "VAT number is required": "Momsnummer krävs",
  "Phone number is required": "Telefonnummer krävs",
  "Invoice delivery method is required": "Fakturabeställningsmetod krävs",
  "Invoice language is required": "Fakturaspråk krävs",
  "Email is required": "E-post krävs",
  "Invalid email address": "Ogiltig e-postadress",
  
  // Customer Validation Error Messages
  "Business type is required": "Företagstyp krävs",
  "Customer name is required": "Kundnamn krävs",
  "SSN is required": "Personnummer krävs",
  "SSN must be exactly 12 digits": "Personnummer måste vara exakt 12 siffror",
  "The last 4 digits of SSN cannot be all zeros.": "De sista 4 siffrorna i personnumret kan inte vara alla nollor.",
  "Organization number is required": "Organisationsnummer krävs",
  "Country is required": "Land krävs",
  "Address is required": "Adress krävs",
  "City is required": "Stad krävs",
  "ZIP code is required": "Postnummer krävs",
  "VAT number is required": "Momsnummer krävs",
  "Invalid VAT number format. It should be between": "Ogiltigt momsnummerformat. Det ska vara mellan",
  "and": "och",
  "digits long.": "siffror långt.",
  "Invalid VAT number format. Expected format:": "Ogiltigt momsnummerformat. Förväntat format:",
  "Phone number is required": "Telefonnummer krävs",
  "Invoice delivery method is required": "Fakturabeställningsmetod krävs",
  "Invoice language is required": "Fakturaspråk krävs",
  "Email is required": "E-post krävs",
  "Invalid email address": "Ogiltig e-postadress",
  "Payment terms are required": "Betalningsvillkor krävs",
  
  ACCOMMODATION_TYPE_LABEL: "Boendetyp",
  DATE_S: "Datum",
  ALLOWANCE_TYPE: "Ersättningstyp",
  ATTACHMENT: "Bilaga",
  PRICE: "Pris",
  ACTIONS: "Åtgärder",
  NO_FILE: "Ingen fil",
  
  // Allowance Type Labels
  MILEAGE_REPORT: "Milersättning",
  TRAVEL_EXPENSES: "Resekostnader",
  MATERIALS_AND_TOOLS: "Material & Verktyg",
  ALLOWANCE_OUTSIDE_SWEDEN: "Traktamente utanför Sverige",
  ALLOWANCE_IN_SWEDEN: "Traktamente i Sverige",
  
  WANT_TO_GET_PAID_FASTER: "Vill du bli betald snabbare? Du kan välja",
  EXPRESS_PAYMENTS: "Expressbetalningu200b",
  TO_SEE_MORE_DETAILS: "För att se mer detaljer innan du fortsätter",
  CLICK_HERE: "Klicka här",
  SUB_TOTAL: "Delsumma",
  VAT_LABEL: "Moms",
  TOTAL: "Totalt",
  SEE_HOW_WE_CALCULATED: "Se hur vi beräknade",
  
  // Services Table translations
  DATE_S_HEADER: "Datum",
  PRICING_TYPE: "Pristyp",
  SERVICE: "Tjänst",
  ADD_NEW_ROW: "Lägg till ny rad",
  CUSTOMER_WILL_PAY: "Kund kommer att betala",
  TIMES: "Tid/Enhet",
  UNITS: "Enheter",
  DISCOUNT: "Rabatt",
  SUBTOTAL: "Delsumma",
  SELECT_DATES_ABOVE: "Välj datum ovan",
  GENERATE_ROW: "Välj datum",
  PAYMENT_PER_DAY: "Betalning per dag",
  PAYMENT_PER_WEEK: "Betalning per vecka",
  PAYMENT_PER_MONTH: "Betalning per månad",
  PAYMENT_AS_AGREED: "Betalning enligt överenskommelse",
  PAYMENT_PER_UNIT: "Betalning per enhet",
  SEARCH_SELECT_SERVICE: "Sök & välj tjänst",
  ENTER_SERVICE_NAME: "Ange tjänst",
  PLEASE_FILL_SERVICE_DESCRIPTION: "Vänligen fyll i tjänstebeskrivning för alla arbetstimmar",
  PLEASE_SELECT_CUSTOMER_FIRST: "Vänligen välj en kund först",
  HH_MM: "TT:MM",
  ENTER_UNITS: "Ange enheter",
  VALUE: "Värde",
  // ROT Service Types
  BUILD: "Bygg",
  ELECTRICITY: "Elektricitet",
  GLASS_SHEET_METAL: "Glas/plåtarbete",
  SOIL_DRAINAGE: "Jord / Dräneringsarbete",
  PAINTING_WALLPAPERING: "Målning / Tapetsering",
  PLUMBING: "VVS",
  MASONRY: "Murning",
  // OTHER_COSTS: "Övriga kostnader",
  
  // RUT Service Types
  CLEANING: "Städning",
  TEXTILE_CLOTHING: "Kläd- och textilvård",
  SNOW_PLOWING: "Snöskottning",
  GARDENING: "Trädgårdsarbete",
  BABYSITTING: "Barnpassning",
  OTHER_CARE: "Personlig omsorg",
  MOVING_SERVICES: "Flytt",
  IT_SERVICES: "IT-tjänster",
  MAJOR_APPLIANCE_REPAIR: "Reparation av vitvaror",
  FURNISHING: "Möblering",
  HOME_MAINTENANCE: "Övervakning av bostad",
  TRANSPORTATION_SERVICES: "Transporttjänster",
  WASHING_AND_CARE_OF_CLOTHING: "Tvätt och vård av kläder",
  PENSION_PAY: "Pensionsbetalning",
  NO_RESULTS_FOUND: "Inga resultat hittades",
  
  // Pension and Holiday Section translations
  PENSION: "Pension",
  HOLIDAY_PAY: "Semesterlön",
  PENSION_ERROR_GROSS_SALARY: "Pensionsalternativet är endast tillgängligt om bruttolönen är 5000 SEK eller mer",
  AVAILABLE_ONLY_REGULAR_ENGAGEMENT: "Endast tillgänglig för Regelmässig/Kontinuerlig engagemangstyp",
  PENSION_NOTE_5000_SEK: "Obs: Pensionsalternativet är endast tillgängligt om bruttolönen är 5000 SEK eller mer.",
  HOLIDAY_PAY_NOTE_190_SEK: "Obs: 190 SEK kommer att dras av från varje semesterutbetalning.",
  
  // Add Deduction Modal translations
  ADD_DEDUCTION: "Lägg till avdrag",
  SELECT_DEDUCTION_TYPE: "Välj avdragstyp",
  PLEASE_SELECT_DEDUCTION_TYPE: "Vänligen välj avdragstyp",
  MILEAGE_REPORT: "Milersättning",
  TRAVEL_EXPENSES_PDF: "Resekostnader enligt bifogad PDF",
  EXPENSES_MATERIALS_TOOLS_PDF: "Utgifter för material och verktyg enligt bifogad PDF",
  ALLOWANCE_OUTSIDE_SWEDEN: "Ersättning utanför Sverige",
  ALLOWANCE_IN_SWEDEN: "Ersättning i Sverige",
  PLEASE_SELECT_DEDUCTION_CONTINUE: "Vänligen välj en avdragstyp för att fortsätta",
  CANCEL: "Avbryt",
  SUBMIT: "Skicka in",
  PLEASE_UPLOAD_PDF: "Vänligen ladda upp en PDF-fil",
  UPLOAD_ONLY_PDF: "Vänligen ladda upp endast PDF-filer",
  FILE_SIZE_LESS_THAN_1MB: "Filstorleken måste vara mindre än 1 MB",

  // Mileage Report Form
  IS_MILEAGE_TAX_FREE: "Är milersättningen skattefri?",
  PLEASE_SELECT_OPTION: "Vänligen välj ett alternativ",
  SELECT_OPTION: "Välj alternativ",
  YES: "Ja",
  NO: "Nej",
  SHOW_MILEAGE_ON_INVOICE: "Vill du visa milersättningen på fakturan?",
  UPLOAD_FILE_PDF_1MB: "Ladda upp fil (endast PDF-filer upp till 1 MB)",
  CHANGE_PDF_FILE: "Ändra PDF-fil",
  UPLOAD_PDF_FILE: "Ladda upp PDF-fil",
  KB: "KB",
  TRAVEL_DATE: "Resedatum",
  PLEASE_SELECT_TRAVEL_DATE: "Vänligen välj resedatum",
  DISTANCE_KM: "Distans (i km)",
  PLEASE_ENTER_DISTANCE: "Vänligen ange distans",
  ENTER_DISTANCE: "Ange distans",
  REASON_FOR_TRIP: "Anledning till resan",
  PLEASE_ENTER_REASON: "Vänligen ange anledning till resan",
  WRITE_HERE: "Skriv här...",
  CAR_REGISTRATION: "Bilregistreringsnummer",
  PLEASE_ENTER_CAR_REG: "Vänligen ange bilregistreringsnummer",
  CAR_REG_PLACEHOLDER: "XXXX XXXX",
  TRIP_STARTED_PLACE: "Resans startplats",
  PLEASE_ENTER_START_PLACE: "Vänligen ange resans startplats",
  ALLOWANCE_PER_KM: "Ersättning per km: 2,50 Kr",
  PLEASE_ENTER_DESCRIPTION_BEFORE_CREATING_INVOICE: "Vänligen ange beskrivning innan du skapar fakturan",
  WORKING_HOUR_AMOUNT_ZERO_ERROR: "En eller flera arbetstimmar har ett belopp på 0. Ange ett giltigt pris innan du skapar fakturan.",
  TOTAL: "Totalt",
  KR: "Kr",
  DESCRIPTION: "Beskrivning",

  // Travel Expenses Form
  SHOW_TRAVEL_EXPENSES_ON_INVOICE: "Vill du visa resekostnader på fakturan?",
  SHOW_ON_INVOICE_QUESTION: "Visa på fakturan?",
  VAT: "Moms",
  PLEASE_SELECT_VAT: "Vänligen välj moms",
  SELECT_VAT: "Välj moms",
  VAT_0: "0%",
  VAT_6: "6%",
  VAT_12: "12%",
  VAT_25: "25%",
  AMOUNT_SEK_EX_VAT: "Belopp i SEK (ex. moms)",
  PLEASE_ENTER_AMOUNT: "Vänligen ange belopp",
  ENTER_AMOUNT: "Ange belopp",
  TOTAL_INC_VAT: "Totalt (inkl. moms):",
  SEK: "SEK",

  // Materials & Tools Form
  IS_MATERIALS_TAX_FREE: "Är utgifterna för material och verktyg skattefria?",
  SHOW_MATERIALS_ON_INVOICE: "Vill du visa utgifter för material och verktyg på fakturan?",
  DATE_OF_PURCHASE: "Inköpsdatum",
  PLEASE_SELECT_PURCHASE_DATE: "Vänligen välj inköpsdatum",

  // Allowance Outside Sweden Form
  IS_ALLOWANCE_OUTSIDE_TAX_FREE: "Är traktamenten utanför Sverige skattefritt?",
  SHOW_ALLOWANCE_OUTSIDE_ON_INVOICE: "Vill du visa traktamenten utanför Sverige på fakturan?",
  TRIP_STARTED_DATE: "Resans startdatum",
  PLEASE_SELECT_START_DATE: "Vänligen välj startdatum",
  TRIP_ENDED_DATE: "Resans slutdatum",
  PLEASE_SELECT_END_DATE: "Vänligen välj slutdatum",
  END_DATE_AFTER_START: "Slutdatumet måste vara efter startdatumet",
  COUNTRY: "Land",
  PLEASE_SELECT_COUNTRY: "Vänligen välj land",
  SELECT_COUNTRY: "Välj land",
  DESTINATION: "Destination",
  PLEASE_ENTER_DESTINATION: "Vänligen ange destination",
  TRAVEL_DAYS: "Resedagar",
  ALLOWANCE_PER_DAY: "Traktamente per dag",

  // Food Expense Dropdown
  FOOD_EXPENSE: "Matkostnad",
  NO_FOOD_EXPENSE: "Ingen matkostnad",
  BREAKFAST: "Frukost (60 SEK)",
  BREAKFAST_NAME: "Frukost",
  LUNCH_OR_DINNER: "Lunch eller middag (105 SEK)",
  LUNCH_OR_DINNER_NAME: "Lunch eller middag",
  LUNCH_AND_DINNER: "Lunch och middag (210 SEK)",
  LUNCH_AND_DINNER_NAME: "Lunch och middag",
  BREAKFAST_LUNCH_AND_DINNER: "Frukost, Lunch och Middag (270 SEK)",
  BREAKFAST_LUNCH_AND_DINNER_NAME: "Frukost, Lunch och Middag",

  // Allowance In Sweden Form
  IS_ALLOWANCE_SWEDEN_TAX_FREE: "Är traktamenten i Sverige skattefritt?",
  SHOW_ALLOWANCE_SWEDEN_ON_INVOICE: "Vill du visa traktamenten i Sverige på fakturan?",
  PARTIAL_WORKDAY_QUESTION: "Blir detta en delvis arbetsdag?",
  SWEDEN: "Sverige",
  SUMMARY: "Sammanfattning",
  INVOICE_DATA_LOADED: "Fakturadata laddad",

  // Other Details Component
  OTHER_DETAILS: "Övriga detaljer",
  CUSTOMER_NOTES: "Kundanteckningar",
  THANKS_FOR_BUSINESS: "Beskriv här vilken typ av arbete du har utfört för både oss och din kund.",
  ADD_SUPPORTING_FILE: "Lägg till bilagefil",
  BROWSE_FILES: "Bläddra bland filer",
  COMMUNICATION_EMAILS: "Kommunikations-e-post",
  ENTER_EMAIL_ID: "Ange e-post-id",
  ADD: "Lägg till",

  // Invoice Footer Component
  GRAND_TOTAL: "Totalsumma :",
  SENDING: "Skickar...",
  SEND_INVOICE: "Skicka faktura",

  // Copy invoice modal
  SELECT_AND_COPY: "Välj & kopiera",

  // Calculation Breakdown Modal
  CALCULATION_BREAKDOWN: "Beräkningsfördelning",
  SHOW_SEPARATELY: "Visa separat",
  TOTAL: "Totalt",
  SUMMARY: "Sammanfattning",
  GROSS_SALARY: "Bruttolön",
  NET_SALARY: "Nettolön",
  INVOICE_VALUE: "Fakturavärde",
  TOTAL_AMOUNT_INC_VAT: "Totalt belopp (inkl. moms)",
  DETAILED_BREAKDOWN: "Detaljerad fördelning",
  COMPONENT: "Komponent",
  AMOUNT: "Belopp",
  BASE_AMOUNT: "Basbelopp",
  VAT: "Moms",
  AMOUNT_INC_VAT: "Belopp inkl. moms",
  FAKTURA_FEE: "Fakturaavgift",
  SOCIAL_FEE: "Socialavgift",
  TO_PAY: "Att betala",
  EXPRESS_FEE: "Expressavgift",
  ADDITIONAL_DETAILS: "Ytterligare detaljer",
  CURRENCY: "Valuta",
  LOYALTY_DISCOUNT: "Lojalitetsrabatt",
  WORKING_DAYS: "Arbetsdagar",
  FREELANCERS: "Frilansare",
  CALCULATION_NOTE: "Denna uppdelning visar hur ditt totala fakturabelopp beräknas baserat på basbelopp, moms, avgifter och avdrag.",
  NO_CALCULATION_DATA: "Ingen beräkningsdata tillgänglig",
  NO_CALCULATION_DATA_DESC: "Se till att du har angett all nödvändig information och försök igen.",
  CLOSE: "Stäng",
  PRINT: "Skriv ut",
  SEE_HOW_WE_CALCULATED: "Se hur vi beräknade",
  HOLIDAY_SAVINGS: "Semestersparande",
  PENSION: "Pension",
  TAX: "Skatt",
  INVOICE_AMOUNT_INC_VAT: "Fakturabelopp inkl. moms",
  INVOICE_AMOUNT_EX_VAT: "Fakturabelopp exkl. moms",
  INVOZIO_PERCENT_FEE: "Invozio procentavgift",
  PENSION_SOCIAL_FEE: "Pensionssocialavgift",
  GROSS_SALARY_INCL_HOLIDAY_PAY: "Bruttolön inkl. semesterersättning",
  HOLIDAY_PAY: "Semesterersättning",
  TOTAL_WORKING_HOURS: "Totala arbetstimmar",
  AMOUNT_AFTER_TAXES: "Belopp efter skatt",
  NET_SALARY_INCL_HOLIDAY_PAY: "Nettolön inkl. semesterersättning",
  DRAFT_INVOICE_DATA_LOADED: "Utkast fakturadata laddad.",
   DRAFT_INVOICE_SAVED_SUCCESSFULLY: "Utkast faktura sparad framgångsrikt!",
  
  // Calculation Breakdown Modal
  HOW_WE_CALCULATE_YOUR_INVOICE: "Så här beräknar vi din faktura",
  INVOICE_DETAILS: "Fakturadetaljer",
  INVOICE_AMOUNT_INCLUDING_VAT: "Fakturabelopp (inklusive moms)",
  INVOICE_AMOUNT_EXCLUDING_VAT: "Fakturabelopp (exklusive moms)",
  FEES: "Avgifter",
  INVOZIO_FEE: "Invozio avgift",
  SOCIAL_FEES: "Socialavgifter",
  SALARY_COMPONENTS: "Lönekomponenter",
  GROSS_SALARY_INCLUDING_HOLIDAY_PAY: "Bruttolön (inklusive semesterersättning)",
  TAX_INFORMATION: "Skatteinformation",
  INCOME_TAX: "Inkomstskatt",
  INVOICE_SUMMARY: "Fakturasammanfattning",
  PENSION_CONTRIBUTION: "Pensionsavgift",
  RUT_DEDUCTION_AMOUNT: "RUT-avdragsbelopp",
  ROT_DEDUCTION_AMOUNT: "ROT-avdragsbelopp",
  SUBMITTING: "Skickar...",
  EXPENSE: "Kostnad",
  ADMINISTRATOR_FEE: "Administratörsavgift",
  ALLOWANCE: "Ersättning",
  ADDITIONAL_INFORMATION: "Ytterligare information",
  LOYALTY_DISCOUNT_ON_INVOZIO_FEE: "Lojalitetsrabatt på Invozio´s avgift",
  HOURS: "Timmar",

  // Tooltip translations
  CURRENCY_TOOLTIP: "Välj den valuta som din faktura ska skickas i.",
  VAT_TOOLTIP: "Ange den momssats som gäller för din tjänst eller produkt.",
  ENGAGEMENT_TYPE_TOOLTIP: "Välj om ditt uppdrag är kontinuerligt (löpande) eller tillfälligt (engångsuppdrag) — detta påverkar hur uppdraget kategoriseras vid fakturering.",
  PRICING_TYPE_TOOLTIP: "Välj hur din prissättning beräknas — till exempel baserat på tid eller ett fast pris.",
  HOURS_PER_DAY_TOOLTIP: "Ange hur många timmar per dag du normalt arbetar med detta uppdrag.",
  HOURLY_PRICE_TOOLTIP: "Ange det belopp du debiterar per arbetad timme.",
  RUT_ROT_DEDUCTION_TYPE_TOOLTIP: "Välj vilken avdragstyp som gäller om din tjänst omfattas av RUT- eller ROT-avdrag.",
  RUT_ROT_INFO_MODAL_TITLE: "Information om RUT/ROT-avdrag",
  RUT_ROT_INFO_MODAL_NOTE: "Obs:",
  RUT_ROT_INFO_MODAL_MESSAGE: "Din lön betalas ut först efter att skatteavdraget har godkänts av Skatteverket.",
  DATES_TOOLTIP: "Ange de datum då arbetet utfördes.",
  CALENDAR_TOOLTIP: "Klicka för att välja ett datum. Dra för att välja flera datum.",
  SHOW_DATES_TOOLTIP: "Välj om arbetsdatumen ska visas på fakturan.",
  PENSION_PAY_TOOLTIP: "Du kan frivilligt avsätta en del av din ersättning (0–3 000 SEK) till din tjänstepension via vår partner SPP.",
  HOLIDAY_PAY_TOOLTIP: "Avsätt 0–50 % av din lön som semesterersättning. Du kan när som helst se och ta ut dina sparade semestermedel under \"Salary Notices\".",
  
  // Currency Info Modal
  CURRENCY_INFO_MODAL_TITLE: "Så här beräknar vi valutakurser",
  CURRENCY_INFO_MODAL_MAIN_TEXT: "Du kan fakturera i EUR, USD, GBP, CHF, CAD, AUD, NOK, DKK, JPY och CNY. Alla löner betalas ut i SEK. Vid konvertering till SEK tillämpar vi en fast valutamarginal på 0.5 %, vilket täcker bankernas kostnader och säkrar växelkursen för din lön.",
  CURRENCY_INFO_MODAL_ADDITIONAL_INFO: "Det exakta SEK-beloppet, efter konvertering och marginal, ser du alltid i ditt lönebesked under Fakturor",
  CURRENCY_INFO_MODAL_CONTACT_TEXT: "Kontakta oss om du har några frågor",
  CURRENCY_INFO_MODAL_CONTACT_EMAIL: "support@invozio.com",

  // VAT Info Modal
  VAT_INFO_MODAL_MAIN_TEXT: "Skatteverkets huvudregel är att varor och tjänster som faktureras inom Sverige har ett momstillägg på 25%. Det finns dock några undantagsfall där momssatsen kan vara 12%, 6% eller 0%.",
  VAT_INFO_MODAL_EXAMPLE: "Exempel på extraordinära omständigheter med 6% moms är upphovsrättsskyddat material.",
  VAT_INFO_MODAL_NOTE_TITLE: "Observera:",
  VAT_INFO_MODAL_NOTE_TEXT: "Denna regel gäller inte för momsbefriad konstnärlig verksamhet. Om du fakturerar för konstnärliga framträdanden eller relaterade tjänster måste 25% moms tillämpas.",
  VAT_INFO_MODAL_EXEMPTION_TEXT: "Export, arbete i internationellt vatten, CSN-berättigad utbildning och vissa typer av sjukvård är momsbefriade. Artist- och musikergage har ett momstillägg på 25%, förutom när artisten eller musikern äger faktureringsföretaget, i vilket fall gagen är momsbefriade. Om du är osäker på vilken momssats som gäller för ditt arbete, tveka inte att kontakta oss på",
  
  // File upload error messages
  FILE_UPLOAD_PDF_ONLY: "Vänligen ladda upp endast PDF-filer",
  FILE_UPLOAD_MAX_SIZE: "Filstorleken får inte överstiga 1 MB",
  FILE_SELECTED: "Fil vald",
  NO_FILE_SELECTED: "Ingen fil vald",

  // Invoice Preview Modal translations
  IN_DRAFT: "I utkast",
  DOWNLOAD: "Ladda ner",
  PRINT: "Skriv ut",
  SEND_INVOICE: "Skicka faktura",
  ADDED_ATTACHMENT: "Bifogade filer",
  CLICK_TO_VIEW_ATTACHMENT: "Klicka för att visa bilaga",
  PREVIEW_INVOICE: "Förhandsgranska faktura",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Kund uppdaterad framgångsrikt",
  FAILED_TO_UPDATE_CUSTOMER: "Misslyckades med att uppdatera kund. Försök igen.",
  FAILED_TO_SAVE_CUSTOMER: "Misslyckades med att spara kund. Försök igen.",
  EDIT_CUSTOMER_MODAL_TITLE: "Redigera kund",
  
  // Freelancer removal confirmation
  REMOVE_FREELANCER_TITLE: "Ta bort frilansare från denna kollektiva faktura?",
  REMOVE_FREELANCER: "Ta bort frilansare",
  CONFIRM_REMOVE_FREELANCER_MESSAGE: "Att ta bort <strong>{{name}}</strong> från denna kollektiva faktura kommer att radera all deras fakturaaktivitetsdata här (datum, timmar, rabatter).<br/><br/>Detta kan inte ångras. Fortsätta?",
  CANCEL_BUTTON: "Avbryt",
  REMOVE_FREELANCER_BUTTON: "Ta bort frilansare",
   NO_CANCEL: "Nej, Avbryt",
  YES_REMOVE: "Ja, Ta bort",
  SELECT_CUSTOMER_FIRST_TOOLTIP: "Välj kund först för att välja arbetstimmar",
  INVITE_FREELANCER_FIRST_ERROR: "Ingen frilansare hittades. Vänligen bjud in frilansaren först, sedan kan du lägga till dem.",
  
  // Express Payment Modal translations
  EXPRESS_PAYMENT_REQUIREMENTS: "Krav för expressbetalning",
  EXPRESS_PAYMENT_INFO_TEXT_1: "Expressbetalning kräver en godkänd kreditstatus för både dig och din kund. Vi kör en UC-kontroll första gången och för varje ny kund, plus en initial och ibland leveranskontroll för att bekräfta fakturan.",
  EXPRESS_PAYMENT_INFO_TEXT_2: "Betalning görs samma dag när alla kontroller är slutförda. Om kunden bekräftar före 14:00 siktar vi på att betala samma dag eller nästa morgon efter helger/helgdagar. Avgiften är 5,9% (min. 590 SEK), jämfört med 1,4% med standardbetalning.",
  EXPRESS_PAYMENT_REQUIREMENTS_TEXT: "Krav: inga betalningsanmärkningar, kund registrerad hos Bolagsverket, arbete under 30 dagar gammalt, faktura godkänd, inga tvister. Inte tillgängligt för privatpersoner eller enskilda firmor. Max fakturabelopp: 60 000 SEK.",
  GOT_IT: "Jag förstår",

  // Bank Information translations
  "Please Add Your Bank Information": "Lägg till din bankinformation",
  "It looks like you forgot to enter your bank details. To complete your setup and receive payments, you can securely enter them here to receive payments and complete your setup.": "Det ser ut som att du glömde anga dina bankuppgifter. För att slutföra din inställning och ta emot betalningar kan du säkert ange dem här för att ta emot betalningar och slutföra din inställning.",
  "Bank": "Bank",
  "Bank Name": "Banknamn",
  "Your Bank Name Here": "Ditt banknamn här",
  "IBAN Number": "IBAN-nummer",
  "BIC Number": "BIC-nummer",
  "Clearing number": "Clearingnummer",
  "Account number": "Kontonummer",
  "Note: Clearing number should be between 4-5 digits and account number can have maximum 10 digits. Special characters are not allowed.": "Obs: Clearingnumret ska vara mellan 4-5 siffror och kontonumret kan ha maximalt 10 siffror. Specialtecken är inte tillåtna.",
  "Save Settings": "Spara inställningar",

  // Auto Generate Items Modal translations
  AUTO_GENERATE_ITEMS: "Generera radobjekt automatiskt",
  AUTO_GENERATE_DESCRIPTION: "Konfigurera parametrarna för att automatiskt generera fakturaradobjekt för valda datum.",
  SELECT_DATES: "Välj datum",
  CLICK_TO_SELECT_DATES: "Klicka för att välja datum",
  HOURS_PER_DAY: "Timmar per dag",
  PRICE: "Timpris",
  PRICING_TYPE: "Pristyp",
  ENTER_AMOUNT: "Ange belopp",
  CHARACTERS: "tecken",
  GENERATES: "Generera objekt",
  PLEASE_SELECT_DATES: "Välj minst ett datum",
  HOURS_REQUIRED: "Timmar per dag krävs",
  HOURS_INVALID_FORMAT: "Ogiltigt tidsformat. Använd hh:mm",
  PRICE_REQUIRED: "Timpris krävs",
  PRICE_MUST_BE_POSITIVE: "Priset måste vara större än 0",
  TASK_DETAILS_REQUIRED: "Tjänstebeskrivning krävs",
  ARE_YOU_SURE_YOU_WANT_TO_SAVE: "Är du säker på att du vill spara fakturan?",
  SAVE_INVOICE: "Spara faktura",
  SUMMARY_GENERATE_TEXT: "Detta kommer att generera",
  SUMMARY_LINE_ITEM: "radobjekt",
  SUMMARY_LINE_ITEMS: "radobjekt",
  SUMMARY_EACH_WITH: "varje med",
  SUMMARY_HOURS_AT: "timmar till",
  ESTIMATED_TOTAL: "Beräknad totalt",
  MINIMUM_INVOICE_AMOUNT_ERROR: "Minst 1000 SEK belopp krävs för att skapa en faktura",
  
  // Logo upload toast messages
  LOGO_FORMAT_NOT_SUPPORTED: "Logoformat stöds inte, endast jpg eller png är tillåtna",
  FILE_TOO_LARGE_1MB: "Filen är för stor. Den maximala tillåtna storleken är 1 MB",
  LOGO_UPLOADED_SUCCESSFULLY: "Logotyp uppladdad framgångsrikt",
  FAILED_TO_UPLOAD_LOGO: "Misslyckades med att ladda upp logotyp",
  USER_NOT_FOUND: "Användare hittades inte",
  LOGO_DELETED_SUCCESSFULLY: "Logotyp raderad framgångsrikt",
  FAILED_TO_DELETE_LOGO: "Misslyckades med att radera logotyp",
  
  // Invoice data toast messages
  FAILED_TO_LOAD_INVOICE: "Misslyckades med att ladda faktura",
  FAILED_TO_CALCULATE_INVOICE: "Misslyckades med att beräkna faktura",
  PLEASE_SELECT_CUSTOMER: "Vänligen välj en kund",
  PLEASE_ENTER_VALID_AMOUNT: "Vänligen ange ett giltigt belopp",
  INVOICE_DATA_COPIED_SUCCESSFULLY: "Faktura {{invoiceNumber}} data kopierad framgångsrikt",
  FAILED_TO_COPY_INVOICE_DATA: "Misslyckades med att kopiera fakturadata",
  INVOICE_SELECTED: "Faktura {{invoiceNumber}} vald",
  INVOICE_EDITED_SUCCESSFULLY: "Faktura redigerad framgångsrikt",
  INVOICE_SAVE_ERROR_500: "Något gick fel när fakturan sparades, denna faktura har blivit avbruten. Vänligen försök igen.",
  
  // Bank details message
  "Your bank details has been added.": "Dina bankuppgifter har lagts till.",
  
  // OTP Modal translations
  "Verify OTP": "Verifiera OTP",
  "Verify your current email": "Verifiera din nuvarande e-postadress",
  "Step 2: Verify your current email": "Steg 2: Verifiera din nuvarande e-postadress",
  "Please check your new email inbox": "Vänligen kontrollera din nya e-postinkorg",
  "for the one-time code.": "för engångskoden.",
  "Enter the OTP sent to your current email address": "Ange OTP som skickats till din nuvarande e-postadress",
  "Verify": "Verifiera",
  "Resend in": "Skicka igen om",
  "Resend": "Skicka igen",
  "Cancel": "Avbryt",
  
  // 401 Error message
  UPDATE_EMAIL_TO_CONTINUE: "Vänligen uppdatera din e-postadress i dina kontoinställningar för att fortsätta.",
  
  // VAT validation errors
  INVALID_VAT_FORMAT_EXPECTED: "Ogiltigt momsregistreringsnummer format. Förväntat format: {{format}}",
  INVALID_VAT_FORMAT_LENGTH: "Ogiltigt momsregistreringsnummer format. Det ska vara mellan {{min}} och {{max}} siffror långt.",
  INVALID_VAT_NUMBER_ERROR: "Begäran misslyckades: Ogiltigt VAT-nummer.",
  
  // Invoice creation success messages
  INVOICE_CREATED_SUCCESSFULLY: "Faktura skapad framgångsrikt",
  PRELIMINARY_INVOICE_CREATED_SUCCESSFULLY: "Preliminär faktura skapad framgångsrikt",

  // Unsaved changes warning modal
  UNSAVED_CHANGES_TITLE: "Osparade ändringar",
  UNSAVED_CHANGES_DESC: "Din faktura har osparade ändringar. Vill du spara dem innan du lämnar, eller fortsätta utan att spara?",
  STAY_ON_PAGE: "Avbryt",
  LEAVE_PAGE: "Lämna sidan",
};
